import { render, staticRenderFns } from "./items-listing-layout.vue?vue&type=template&id=56a94dec&"
import script from "./items-listing-layout.vue?vue&type=script&lang=ts&"
export * from "./items-listing-layout.vue?vue&type=script&lang=ts&"
import style0 from "./items-listing-layout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports